import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { NotificationsService } from '@mt-ng2/notifications-module';
import { ClaimsService, ClaimValues } from '@mt-ng2/auth-module';

import { LocationService } from '../services/location.service';
import { ILocation } from '../../model/interfaces/location';
import { ClaimTypes } from '../../model/ClaimTypes';

@Component({
    templateUrl: './location-detail.component.html',
    standalone: false
})
export class LocationDetailComponent implements OnInit {
    location: ILocation;
    canEdit: boolean;
    canAdd: boolean;

    constructor(
        private locationService: LocationService,
        private claimsService: ClaimsService,
        private route: ActivatedRoute,
        private notificationsService: NotificationsService,
        private router: Router,
    ) {}

    ngOnInit(): void {
        // check claims
        this.canEdit = this.claimsService.hasClaim(ClaimTypes.Locations, [ClaimValues.FullAccess]);
        this.canAdd = this.canEdit;
        // get current id from route
        const id = this.getIdFromRoute(this.route, 'locationId');
        if (id) {
            this.getLocationById(id);
        } else {
            void this.router.navigate(['locations']); // if no id found, go back to list
        }
    }

    getLocationById(id: number): void {
        this.locationService.getById(id).subscribe((location) => {
            if (location === null) {
                this.notificationsService.error('Location not found');
                void this.router.navigate(['locations']);
            }
            this.location = location;
        });
    }

    getIdFromRoute(route: ActivatedRoute, param: string): number {
        const id = route.snapshot.paramMap.get(param);
        return isNaN(parseInt(id, 10)) ? null : parseInt(id, 10);
    }
}
